import React from "react"
import Label from "components/navigators/Label"
import I18n from "i18n"
import { TabBarLabelProps } from "components/types"

export default (props: TabBarLabelProps) => (
  <Label label={I18n.t("title_buyer_orders_history_tab")} {...props} />
)
